import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import NotesHero from './components/NotesHero';
import FeaturedArticles from './components/FeaturedArticles';
import CategorySection from './components/CategorySection';
import NotesCta from './components/NotesCta';
import CategoryResultSection from './components/CategoryResultSection';
import InvalidCategoryNotice from './components/InvalidCategoryNotice';
import { noteCategories } from '@/mocks/notes';

export default function NotesPage() {
  const [searchParams] = useSearchParams();
  const categoryParam = searchParams.get('category');
  const activeCategory = noteCategories.find((c) => c.id === categoryParam) ?? null;
  const hasCategoryParam = categoryParam !== null;

  // 分類切換時捲回頁面頂部（SEO 標題與描述由全域 SeoManager 統一處理）。
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [categoryParam]);

  return (
    <div className="min-h-screen bg-[#faf8f5]">
      <Navbar />
      <main>
        {activeCategory ? (
          <CategoryResultSection key={activeCategory.id} category={activeCategory} />
        ) : hasCategoryParam ? (
          <InvalidCategoryNotice />
        ) : (
          <>
            <NotesHero />
            <FeaturedArticles />
            <CategorySection />
            <NotesCta />
          </>
        )}
      </main>
      <Footer />
    </div>
  );
}